{
  "label": "équipement",
  "name": "Nom",
  "model": "Gamme",
  "type": "Type",
  "serialNumber": "Numéro de série",
  "sector": "Secteur",
  "connectivity": "Connectivité",
  "certificate": "Certificat",
  "state": "État",
  "states": {
    "activated": "Activé",
    "deactivated": "Désactivé",
    "registered": "Nouveau"
  },
  "actions": {
    "scheduled": {
      "title": "Actions en cours ?",
      "yes": "Oui",
      "no": "Non",
      "error": "Indéterminé"
    }
  },
  "firmwareVersion": "Version logicielle",
  "hardwareVersion": "Version matérielle",
  "updateCertificate": "Mise à jour du certificat",
  "updateFirmware": "Mise à jour du firmware",
  "updateState": {
    "activate": {
      "title": "Activer",
      "execute": "Activer l'équipement",
      "description": "L'équipement {name} va être activé."
    },
    "deactivate": {
      "title": "Désactiver",
      "execute": "Désactiver l'équipement",
      "description": "L'équipement {name} va être désactivé.",
      "warning": "Un équipement désactivé ne bénéficie plus des mises à jour manuelles et automatiques des certificats.",
      "error": "Cet équipement ne peut pas être désactivé parce qu'il a une opération en attente ou en cours."
    }
  },
  "month": "{n} mois | {n} mois",
  "year": "{n} an | {n} ans",
  "custom": "Personnalisé",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "Aucun équipement n'a été trouvé",
  "delete": {
    "execute": "Supprimer l'équipement",
    "description": "L'équipement {name} va être supprimé.",
    "warning": "Les opérations associées à l'équipement seront également supprimées.",
    "error": "Cet équipement ne peut pas être supprimé parce qu'il a une opération en attente ou en cours."
  },
  "description": {
    "title": "Description",
    "idCard": "Carte d'identité",
    "state": "État",
    "connectivity": "Connectivité",
    "lastConnection": "Dernière connexion",
    "certificateValidityDate": "Date de validité du certificat",
    "lastChange": "Dernier changement",
    "configurationApplicationDate": "Date d'application de la configuration",
    "lastRebootDate": "Date du dernier redémarrage",
    "firstCommissioningDate": "Date de la première mise en service",
    "lastFirmwareUpdate": "Dernière mise à jour du firmware",
    "mobileNetwork": "Réseau mobile",
    "gsmFrequencyBand": "Bande de fréquence GSM",
    "communicationProtocol": "Protocole de communication"
  },
  "certificateForm": {
    "expirationDate": "Date d'expiration du certificat",
    "certificateOrigin": "Origine du certificat",
    "lastUpdate": "Dernière mise à jour du certificat"
  },
  "firmwareForm": {
    "title": "Firmware",
    "version": "Version",
    "description": "Description du firmware",
    "origin": "Origine du firmware",
    "lastUpdate": "Dernière mise à jour"
  },
  "configurationForm": {
    "title": "Configuration"
  },
  "operation": {
    "cancel": {
      "tooltip": {
        "enabled": "Annuler l’opération",
        "disabled": "Vous ne pouvez plus annuler l’opération"
      },
      "confirm": {
        "title": "Annulation de l'opération",
        "description": "Cette opération sera annulée. Cette action est inversible."
      }
    },
    "unitary": "Unitaires",
    "campaign": "Campagnes",
    "update": {
      "tooltip": {
        "enabled": "Mettre à jour l'opération",
        "disabled": "Vous ne pouvez plus modifier l’opération"
      }
    }
  },
  "additionalMetadata": {
    "title": "Métadonnées additionnelles",
    "options": {
      "title": "Options",
      "software": {
        "1": "Automatisme",
        "2": "Poste de Relèvement",
        "3": "Serveur Web",
        "4": "Synoptiques Web",
        "5": "Secours IP ADSL / GSM",
        "6": "IEC60870-5-104 Slave"
      },
      "numericSoftware": {
        "1": "Nombre d'informations : {value}",
        "2": "Nombre de modules I/O : {value}",
        "3": "Nombre de modules COM : {value}"
      }
    },
    "communicationModules": {
      "title": "Modules de communication"
    },
    "modulesIo": {
      "title": "Modules I/O"
    },
    "modules": {
      "location": "Position",
      "module": "Module"
    }
  },
  "warningMessage": "L'équipement a déjà une opération du même type planifiée ou en cours"
}
